import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/articles';

export default function SEOArticlesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-500 mb-3">
            Artykuły SEO
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Kakobuy Spreadsheet – Baza Wiedzy i Poradników
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Poznaj nasze szczegółowe poradniki o Kakobuy Spreadsheet. Od sneakersów po bezpieczeństwo zakupów – wszystko w jednym miejscu.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {seoArticles.map((article) => (
            <Link
              key={article.id}
              to={article.slug}
              className="group bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 overflow-hidden transition-all cursor-pointer flex flex-col"
            >
              <div className="w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="text-xs font-semibold tracking-widest uppercase text-primary-500 mb-2">
                  {article.category}
                </span>
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-2 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                  {article.description}
                </p>
                <div className="mt-4 flex items-center gap-1.5 text-primary-500 text-xs font-semibold">
                  <span>Czytaj więcej</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}